export enum CarFuelEnum {
  alcool = 'ALCOOL',
  flex = 'FLEX',
  gasolina = 'GASOLINA',
  diesel = 'DIESEL',
  gnv = 'GNV'
}
